var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "2 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5149 9.03528C19.5149 14.3743 15.3229 20.0003 8.07693 20.0003V19.9973C6.39693 19.9993 4.74393 19.6123 3.23993 18.8723C2.85593 18.6843 2.95593 18.1023 3.37593 18.0313C5.27393 17.7143 6.97893 16.9753 7.84993 15.7233C2.83393 12.8163 2.92193 7.75428 3.20193 5.67228C3.25293 5.29828 3.70593 5.14928 3.94993 5.43228C5.84193 7.60928 8.14293 9.19728 11.4939 8.95828C11.1769 7.55528 11.6109 6.08528 12.6339 5.09828C14.2209 3.56828 16.7159 3.64628 18.2079 5.27328C18.5959 5.73328 19.4889 6.05328 20.3689 5.64928C20.7119 5.49228 21.0759 5.78728 20.9859 6.16128C20.6566 7.53764 19.9988 8.37915 19.6867 8.77827C19.581 8.91359 19.5149 8.99806 19.5149 9.03528Z",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "#45655E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.52e98dd8.svg";
export { ForwardRef as ReactComponent };